
import { Notification, MessageBox } from 'element-ui';
import router from '.';
import 'nprogress/nprogress.css';
import { Route } from 'vue-router';

import { getExpireTime, getUserToken, setExpireTime, setUserToken } from '@/utils/cookies';
import { UserModule } from '@/store/modules/user';
import { freeLevel, getCompanyLimit } from '@/api/company';
import { getUserInfo, logout, swishCompany } from '@/api/users';
const whiteList = ['/register'];
// 赵子龙说的这几个不弹窗
const settingList = ['/Staff/all', '/Customer/list', '/Staff/role', '/Staff/department', '/Device/toDevice'];

router.beforeEach(async(to: Route, _: Route, next: any) => {
  let token: any = getUserToken();
  if (!token) {
    // Has no token
    if (whiteList.indexOf(to.path) !== -1) {
      // In the free login whitelist, go directly
      next();
    } else {
      UserModule.ResetToken();
      window.location.href = location.protocol + process.env.VUE_APP_LOGIN_URL;
    }
    return;
  }
  if (typeof token !== 'object') {
    token = JSON.parse(token as string);
  }
  if ((!token.company_id || parseInt(token.company_id) === 0) && (!UserModule.getCompanyId || parseInt(UserModule.getCompanyId) === 0)) {
    next();
    return;
  }
  if (to.query.t) {
    next();
    return;
  }
  let parameters: any = {};
  parameters.company_id = token.company_id && parseInt(token.company_id) !== 0 ? token.company_id : UserModule.getCompanyId;
  parameters.user_id = token.user_id;

  getCompanyLimit(parameters).then(async(res) => {
    if (res.data) {
      let limit:any = res.data;
      if (parseInt(limit.limit) !== 0) {
        await getUserInfo({ user_id: UserModule.getUserId, company_id: UserModule.getCompanyId }).then(async(res:any) => {
          await UserModule.setLogin(res.data);
        });
      }
      let companyInfo = UserModule.getCompany;
      let dialogInfo:any = {};
      let companyList: any = res.data.company_list;

      if (companyInfo && companyInfo.id) {
        let vipLev:number = parseInt(companyInfo.vip_level.substr(0, 1));
        // 1 报修 2 内报 3 专维
        switch (parseInt(limit.limit)) {
          case 1:
            if (parseInt(companyInfo.super_admin) === 1) {
              if (vipLev !== 1) {
                dialogInfo.title = '<div class="title"><strong>尊敬的会员，' + companyInfo.name + '将于' + limit.day + '天后（' + limit.time +
                '）到期，逾期将无法正常使用报修管家，如需继续使用该公司业务，请联系管理员续费。</strong></div>';
                dialogInfo.title = dialogInfo.title + '<div class="content">1、' + companyInfo.vip_level_name + '设置部门数量' + limit.dept_number + '个（免费版' + (vipLev === 2 ? 3 : 1) + '个），服务部门' +
                  limit.dept_service_number + '个（免费版1个），权限人数共' + limit.set_role_user_number + '个（免费版1个）；您设置部门数量' +
                  limit.deptNum + '个，服务部门' + limit.deptServiceNum + '个，权限人数共' + limit.all_role_user_number + '个；<br/> ' +
                  '2、当您选择使用免费版之后，系统不会删除您已经设置保存的部门、角色、人员数据，但会默认将部门、角色、人员之间的关系清除，您需要到管理后台的公司管理模块下的“人员列表”、“角色管理”、“部门管理”中重新设置部门、服务部门、人员角色。</div>';
              } else {
                dialogInfo.title = '<div class="title"><strong>尊敬的会员，' + companyInfo.name + companyInfo.vip_level_name + '将于' + limit.day + '天后（' + limit.time + '）到期，逾期将无法正常使用报修管家，如需继续使用' +
                companyInfo.vip_level_name + '请致电报修管家（<a href="#" class="font-default">010-62111361</a>），享受更优质的服务。</strong></div>';
                dialogInfo.title = dialogInfo.title + '<div class="content">1、' + companyInfo.vip_level_name + '设置部门数量' + limit.dept_number + '个（免费版0个），权限人数共' + limit.set_role_user_number +
                '个（免费版0个）；您设置部门数量' + limit.deptNum + '个；<br/> ' +
                '2、当您选择使用免费版之后，系统不会删除您已经设置保存的部门、角色、人员数据，但会默认将部门、角色、人员之间的关系清除，您需要到管理后台的公司管理模块下的“人员列表”、“角色管理”、“部门管理”中重新设置部门、服务部门、人员角色。</div>';
              }
            } else {
              dialogInfo.title = '<div class="title"><strong>尊敬的会员，' + companyInfo.name + '将于' + limit.day + '天后（' + limit.time + '）到期，逾期将无法正常使用报修管家，如需继续使用该公司业务，请联系管理员续费。</strong></div>';
              dialogInfo.content = '';
            }
            break;
          case 2:
            if (parseInt(companyInfo.super_admin) === 1) {
              dialogInfo.title = '<div class="title"><strong>尊敬的会员，' + companyInfo.name + companyInfo.vip_level_name + '将于' + limit.day + '天前（' + limit.time +
                '）到期，逾期将于' + limit.after_day + '天后' + limit.delay_time + '无法正常使用报修管家，如需继续使用' + companyInfo.vip_level_name +
                '请致电报修管家（<a href="#" class="font-default">010-62111361</a>），享受更优质的服务.</strong></div>';
              if (vipLev !== 1) {
                dialogInfo.title = dialogInfo.title + '<div class="content">1、' + companyInfo.vip_level_name + '设置部门数量' + limit.dept_number + '个（免费版' + (vipLev === 2 ? 3 : 1) + '个），服务部门' +
                  limit.dept_service_number + '个（免费版1个），权限人数共' + limit.set_role_user_number + '个（免费版1个）；您设置部门数量' +
                  limit.deptNum + '个，服务部门' + limit.deptServiceNum + '个，权限人数共' + limit.all_role_user_number + '个；<br/> ' +
                  '2、当您选择使用免费版之后，系统不会删除您已经设置保存的部门、角色、人员数据，但会默认将部门、角色、人员之间的关系清除，您需要到管理后台的公司管理模块下的“人员列表”、“角色管理”、“部门管理”中重新设置部门、服务部门、人员角色。';
              } else {
                dialogInfo.title = dialogInfo.title + '<div class="content">1、' + companyInfo.vip_level_name + '设置部门数量' + limit.dept_number + '个（免费版0个），权限人数共' + limit.set_role_user_number +
                '个（免费版0个）；您设置部门数量' + limit.deptNum + '个，权限人数共' + limit.all_role_user_number + '个；<br/> ' +
                '2、当您选择使用免费版之后，系统不会删除您已经设置保存的部门、角色、人员数据，但会默认将部门、角色、人员之间的关系清除，您需要到管理后台的公司管理模块下的“人员列表”、“角色管理”、“部门管理”中重新设置部门、服务部门、人员角色。</div>';
              }
            } else {
              dialogInfo.title = '尊敬的会员，' + companyInfo.name + companyInfo.vip_level_name + '将于' + limit.day + '天前（' + limit.time + '）到期，逾期将于' + limit.after_day + '天后' + limit.delay_time +
              '无法正常使用报修管家，如需继续使用该公司业务，请联系管理员续费。</div>';
              dialogInfo.content = '';
            }
            break;
          case 3:
            if (parseInt(companyInfo.super_admin) === 1) {
              dialogInfo.title = ' <div class="title"><strong>尊敬的会员，' + companyInfo.name + ' ' + companyInfo.vip_level_name + '已经到期，如需继续使用' + companyInfo.vip_level_name +
              '请致电报修管家（<a href="#" class="font-default">010-62111361</a>），享受更优质的服务.</strong></div>';
              if (vipLev !== 1) {
                dialogInfo.title = dialogInfo.title + '<div class="content">1、' + companyInfo.vip_level_name + '设置部门数量' + limit.dept_number + '个（免费版' + (vipLev === 2 ? 3 : 1) + '个），服务部门' +
                  limit.dept_service_number + '个（免费版1个），权限人数共' + limit.set_role_user_number + '个（免费版1个）；您设置部门数量' +
                  limit.deptNum + '个，服务部门' + limit.deptServiceNum + '个，权限人数共' + limit.all_role_user_number + '个；<br/> ' +
                  '2、当您选择使用免费版之后，系统不会删除您已经设置保存的部门、角色、人员数据，但会默认将部门、角色、人员之间的关系清除，您需要到管理后台的公司管理模块下的“人员列表”、“角色管理”、“部门管理”中重新设置部门、服务部门、人员角色。</div>';
              } else {
                dialogInfo.title = dialogInfo.title + '<div class="content">1、' + companyInfo.vip_level_name + '设置部门数量' + limit.dept_number + '个（免费版0个），权限人数共' + limit.set_role_user_number +
                '个（免费版0个）；您设置部门数量' + limit.deptNum + '个；<br/> ' +
                '2、当您选择使用免费版之后，系统不会删除您已经设置保存的部门、角色、人员数据，但会默认将部门、角色、人员之间的关系清除，您需要到管理后台的公司管理模块下的“人员列表”、“角色管理”、“部门管理”中重新设置部门、服务部门、人员角色。</div>';
              }
            } else {
              dialogInfo.title = '<div class="title"><strong>您好，' + companyInfo.name + '公司版本发生变化，暂时无法使用，如需继续使用该公司业务，请联系管理员续费;如使用其他公司业务，请切换主单位。<strong></div>';

              let str = '';
              let isMain = '';
              str = '<div class="toggle-primary-unit-box" style="max-height: 220px;">';
              // '<div class="clearfix margintb20"><el-row :gutter="40" class="toggleDefaultShow">' +
              //   '<div class="fleft" :span="12">个人</div>' +
              //   '<div class="fright" style="text-align:right"><div class="el-button el-button--primary el-button--small" onclick="doSwitchCompany()">切换个人</div></div>' +
              // '</el-row></div>';
              for (let m = 0; m < companyList.length; m++) {
                if (parseInt(companyList[m].is_default) === 1) {
                  isMain = '(主单位)';
                } else {
                  isMain = '';
                }
                str += '<div class="clearfix margintb20"><el-row :gutter="40" class="toggleDefaultShow">' +
                          '<div class="fleft">' +
                            '<span>' + isMain + '</span>' + companyList[m].name +
                // '<div class="deadline">' + companyList[m].vip_level_name + '(' + parseTime(companyList[m].vip_invalid_time, '{y}-{m}-{d}') + '到期)</div>' +
                '</div><div class="fright">' +
                            '<div  class="el-button el-button--primary el-button--small el-button-switch" onclick="doSwitchCompany(' + companyList[m].id + ')">切换主单位</div>' +
                          '</div>' +
                          '</el-row></div>';
              }
              str += '</div>';
              dialogInfo.title += str;

              // <!-- 非管理员 看公司数 显示不同div -->
              // {if count($userAlreadJoinCompany) > 1 }
              //     <div style="font-size:120%">
              //         <strong>尊敬的会员，{$userInfo['company_name']} {$userInfo['vip_level_name']}已经到期，如需继续使用该公司业务，请联系管理员续费;如使用其他公司业务，请切换主单位。</strong>
              //     </div>
              //     <br>
              //     {foreach $userAlreadJoinCompany as $key => $value}
              //         <div class="am-form-group am-g">
              //             <div class="am-u-lg-7">{if $value['is_default'] == 1}(主单位) {/if} {$value['name']}</div>
              //             <div class="am-u-lg-5 am-g">
              //                 <button type="button" cid = "{$value['id']}" class="am-btn am-btn-secondary am-radius am-u-lg-5 am-btn-xl am-btn-paddingcustom switchs  " >切换主单位</button>
              //             </div>
              //         </div>
              //     {/foreach}
              // {else/}
              //     <div style="font-size:120%">
              //         <strong>尊敬的会员，{$userInfo['company_name']} {$userInfo['vip_level_name']}已经到期，如需继续使用该公司业务，请联系管理员续费。</strong>
              //     </div>
              // {/if}
            }
            break;
          case 4:
            if (parseInt(companyInfo.super_admin) === 1) {
              if (vipLev === 3) {
                dialogInfo.title = '<div class="title"><strong>尊敬的会员，' + companyInfo.name + '已经降级为' + companyInfo.vip_level_name +
                '，部门数量、服务部门数量、订单处理权限人数、任务处理权限人数超过版本限制，如需正常使用，请立即去设置相关数量</strong></div>';
                dialogInfo.title = dialogInfo.title + '<div class="content">1、' + companyInfo.vip_level_name + '设置部门数量' + limit.dept_number + '个，服务部门' +
                  limit.dept_service_number + '个，权限人数共' + limit.set_role_user_number + '个，公司客户' + limit.customer_company_number + '个，订单数量' + limit.order_number + '个；您设置部门数量' + limit.deptNum + '个，服务部门' +
                   +limit.deptServiceNum + '个，权限人数共' + limit.all_role_user_number + '个，公司客户数量' + limit.cusCompanyNum + '个，订单数量' + limit.orderNum + '个；<br/>' +
                  '2、当您选择使用免费版之后，系统不会删除您已经设置保存的部门、角色、人员数据，但会默认将部门、角色、人员之间的关系清除，您需要到管理后台的公司管理模块下的“人员列表”、“角色管理”、“部门管理”及客户管理模块下的“所有客户”中重新设置部门、服务部门、人员、角色、客户。</div>';
              } else {
                dialogInfo.title = '<div class="title"><strong>尊敬的会员，' + companyInfo.name + '已经降级为' + companyInfo.vip_level_name + '，部门数量、查看报修单权限人数超过版本限制，如需正常使用，请立即去设置相关数量</strong></div>';
                dialogInfo.title = dialogInfo.title + '<div class="content">1、' + companyInfo.vip_level_name + '设置部门数量' + limit.dept_number + '个，权限人数共' + limit.set_role_user_number +
                '个；您设置部门数量' + limit.deptNum + '个；<br/> ' +
                '2、当您选择使用免费版之后，系统不会删除您已经设置保存的部门、角色、人员数据，但会默认将部门、角色、人员之间的关系清除，您需要到管理后台的公司管理模块下的“人员列表”、“角色管理”、“部门管理”中重新设置部门、服务部门、人员角色。</div>';
              }
            } else {
              dialogInfo.title = '<div class="title"><strong>您好，' + companyInfo.name + '公司版本发生变化，暂时无法使用，如需继续使用该公司业务，请联系管理员续费;如使用其他公司业务，请切换主单位。<strong></div>';

              let str = '';
              let isMain = '';
              str = '<div class="toggle-primary-unit-box" style="max-height: 290px;">';
              // '<div class="clearfix margintb20"><el-row :gutter="40" class="toggleDefaultShow">' +
              //   '<div class="fleft" :span="12">个人</div>' +
              //   '<div class="fright" style="text-align:right"><div class="el-button el-button--primary el-button--small" onclick="doSwitchCompany()">切换个人</div></div>' +
              // '</el-row></div>';
              for (let m = 0; m < companyList.length; m++) {
                if (parseInt(companyList[m].is_default) === 1) {
                  isMain = '(主单位)';
                } else {
                  isMain = '';
                }
                str += '<div class="clearfix margintb20"><el-row :gutter="40" class="toggleDefaultShow">' +
                          '<div class="fleft">' +
                            '<span>' + isMain + '</span>' + companyList[m].name +
                // '<div class="deadline">' + companyList[m].vip_level_name + '(' + parseTime(companyList[m].vip_invalid_time, '{y}-{m}-{d}') + '到期)</div>' +
                          '</div><div class="fright">' +
                            '<div  class="el-button el-button--primary el-button--small el-button-switch" onclick="doSwitchCompany(' + companyList[m].id + ')">切换主单位</div>' +
                          '</div>' +
                          '</el-row></div>';
              }
              str += '</div>';
              dialogInfo.title += str;

              // <!-- 非管理员 看公司数 显示不同div -->
              //       {if count($userAlreadJoinCompany) > 1 }
              //           <div style="font-size:120%">
              //               <strong>您好，{$userInfo['company_name']}公司版本发生变化，暂时无法使用，如需继续使用该公司业务，请联系管理员续费;如使用其他公司业务，请切换主单位。</strong>
              //           </div>
              //           <br>
              //           {foreach $userAlreadJoinCompany as $key => $value}
              //               <div class="am-form-group am-g">
              //                   <div class="am-u-lg-7">{if $value['is_default'] == 1}(主单位) {/if} {$value['name']}</div>
              //                   <div class="am-u-lg-5 am-g">
              //                       <button type="button" cid = "{$value['id']}" class="am-btn am-btn-secondary am-radius am-u-lg-5 am-btn-xl am-btn-paddingcustom switchs  " >切换主单位</button>
              //                   </div>
              //               </div>
              //           {/foreach}
              //       {else/}
              //           <div style="font-size:120%">
              //               <strong>您好，{$userInfo['company_name']}公司版本发生变化，暂时无法使用，如需继续使用该公司业务，请联系管理员进行处理。</strong>
              //           </div>
              //       {/if}
            }
            break;
        }
        showDialog(dialogInfo, parseInt(limit.limit), parseInt(companyInfo.super_admin) === 1, next, to);
      }

      (window as any).doSwitchCompany = function(val: any) {
        MessageBox.close();
        let _this = this;
        MessageBox.confirm('是否切换主单位?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (val) {
            switchCompanyData(val, _this);
          } else {
            let token:any = getUserToken();
            if (typeof token !== 'object') {
              token = JSON.parse(token as string);
            }
            token.company_id = '0';
            setUserToken(JSON.stringify(token));
            UserModule.setMainComapy('');
            _this.$router.push({
              path: '/Index'
            });
            setTimeout(() => {
              window.location.reload();
            }, 100);
          }
        }).catch(() => {
          showDialog(dialogInfo, parseInt(limit.limit), parseInt(UserModule.getCompany.super_admin) === 1, next, to);
        });
      };
    }
  }

  );
  next();
});
function switchCompanyData(companyId:string, _this:any) {
  let pamars:any = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId,
    change_company_id: companyId,
    need_auth: 1
  };
  swishCompany(pamars).then((res:any) => {
    let token:any = getUserToken();
    Notification({
      title: '提示',
      message: res.msg,
      offset: 100,
      type: 'success'
    });
    if (typeof token !== 'object') {
      token = JSON.parse(token as string);
    }
    token.company_id = companyId;
    setUserToken(JSON.stringify(token));
    _this.$router.push({
      path: '/Index'
    });
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }).catch(err => {
    Notification({
      title: '提示',
      message: err.msg,
      offset: 100,
      type: 'success'
    });
  });
}
function showDialog(dialogInfo:any, type:number, isSuperAdmin:boolean, next:any, to:any) {
  if (type === 0) {
    return;
  }
  let confirmButtonText = '';
  let cancelButtonText = '';
  let showCancelButton = false;
  let showConfirmButton = false;
  let customClassShow = '';
  switch (type) {
    case 1:
      // if (isSuperAdmin) {
      //   showCancelButton = true;
      //   showConfirmButton = true;
      //   confirmButtonText = '使用免费版';
      //   cancelButtonText = '取消';
      //   customClassShow = 'dialog-custom-vip';
      // } else {
      showConfirmButton = false;
      showCancelButton = true;
      cancelButtonText = '我知道了';
      confirmButtonText = '';
      customClassShow = '';
      // }
      break;
    case 2:
      if (isSuperAdmin) {
        showCancelButton = true;
        showConfirmButton = true;
        confirmButtonText = '使用免费版';
        cancelButtonText = '取消';
        customClassShow = 'dialog-custom-vip';
      } else {
        showConfirmButton = false;
        showCancelButton = true;
        cancelButtonText = '我知道了';
        confirmButtonText = '';
        customClassShow = '';
      }
      break;
    case 3:
      showCancelButton = false;
      cancelButtonText = '';
      if (isSuperAdmin) {
        showConfirmButton = true;
        confirmButtonText = '使用免费版';
        customClassShow = 'dialog-custom-vip';
      } else {
        showConfirmButton = true;
        confirmButtonText = '退出登陆';
        customClassShow = 'dialog-custom-vip';
      }
      break;
    case 4:
      showCancelButton = false;
      cancelButtonText = '';
      if (isSuperAdmin) {
        showConfirmButton = true;
        confirmButtonText = '立即去设置';
        customClassShow = 'dialog-custom-vip';
      } else {
        showConfirmButton = false;
        confirmButtonText = '';
        customClassShow = 'dialog-custom-vip';
      }
      break;
  }
  if (type === 4) {
    // 立即去设置只能打开所有人员、客户
    if (settingList.indexOf(to.path) !== -1 && isSuperAdmin) {
      setExpireTime('');
      next();
      return;
    }
  } else {
    if(type === 3){
      setExpireTime('');
    }else{
      let time:any = getExpireTime();
      if (time && new Date().getTime() - parseInt(time) < 10 * 60 * 1000) {
        next();
        return;
      }
    }
  }

  // if (MessageBox) {
  //   MessageBox.close();
  // }

  MessageBox.confirm(
    dialogInfo.title,
    {
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      showCancelButton: showCancelButton,
      showConfirmButton: showConfirmButton,
      customClass: customClassShow,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      showClose: false,
      dangerouslyUseHTMLString: true,
      closeOnHashChange: false,
      center: true
    }
  ).then(() => {
    if (type === 2) {
      setFreeLevel(next);
      // 使用免费版
    } else if (type === 3) {
      if (isSuperAdmin) {
        setFreeLevel(next);
      } else {
        tologout();
      }
    } else {
      next({ path: '/Staff/all',
        query: {},
        replace: true
      });
    }
  }).catch(() => {
    setExpireTime(new Date().getTime() + '');
  });
}
function setFreeLevel(next:any) {
  let parameters: any = {};
  parameters.company_id = UserModule.getCompanyId;
  parameters.company_name = UserModule.getCompanyName;
  parameters.vip_level = UserModule.company.vip_level;
  freeLevel(parameters).then(res => {
    next({ path: '/Index',
      query: {},
      replace: true
    });
    setTimeout(() => {
      window.location.reload();
    }, 100);
  });
}
function tologout() {
  let parmas:any = {};
  parmas.account_id = UserModule.getAccountId;
  logout(parmas).then(res => {
    setExpireTime('');
    UserModule.ResetToken();
    window.location.href = location.protocol + process.env.VUE_APP_LOGIN_URL;
  }).catch(err => {
    let msg = err.msg;
  });
}
